import axios from 'axios'
import { RegisterDto, UserProfileDto } from '../models/dto/UserProfile'
 

const API_URL = process.env.REACT_APP_API_URL
const LOGIN_URL = `${API_URL}/login`


export function VerifyEmailToken(token: string) {
  return axios.post(`${LOGIN_URL}/verify-email-token`, {token: token})
}

export function UpdateNewPasswrod(token: string, password: string) {
  return axios.post(
    `${LOGIN_URL}/update-password`,
    {newpassword: password},
    {
      headers: {Authorization: `${token}`},
    }
  )
}
export function Register(payload: RegisterDto) {
  return axios.post(`${LOGIN_URL}/register`, payload)
}

